<template>
  <NavBar />
  <header class="lg:px-16 px-5 bg-white flex flex-wrap items-center py-3">
    <div class="flex-1 flex justify-between items-center">
      <div class="relative">
        <a href="javascript.void(0)" class="block text-3xl font-redHat text-[#F5CA40] font-bold">
          Laporan Deposit Customer
        </a>
        <!-- <p class="block text-xl font-redHat text-[#F5CA40] font-bold">Verifikasi Data</p> -->
      </div>
      <!-- <p class="block text-xl font-redHat text-[#F5CA40] font-bold">Story Instagram</p> -->
    </div>

    <div class="hidden md:flex md:items-center md:w-auto w-full" id="menu">
      <nav>

        <ul class="md:flex items-center justify-between text-base text-gray-700 pt-3 md:pt-0 gap-1">

          <!-- <li>
            <div
              class="relative flex items-center p-0 rounded-[8px] w-[250px] max-w-lg h-[40px] border-[0.5px] border-[#00000]">
              <input type="text" v-model="searchQuery" @input="filterTable"
                class="rounded-[8px] p-2.5 px-6 w-full h-full focus:border-blue-500 focus:ring focus:ring-blue-200 focus:outline-none"
                name="search" placeholder="Cari">

              <button type="submit"
                class="absolute right-2 top-1/2 transform -translate-y-1/2 z-10 bg-white  p-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>
              </button>
            </div>
          </li> -->

          <li v-if="this.records && this.records.length > 0">
            <div @click="convertToExcel"
              class="font-redHat text-base  h-[40px] w-[150px] rounded-md text-green-600  border-2 border-green-600 me-2 cursor-pointer">
              <div class="flex justify-center items-center h-full gap-2">
                <img src="../../../assets/img/icon_excel.png" alt="">
                Export Excel
              </div>
            </div>
          </li>

          <li>
            <Datepicker v-model="dateRange" range="true" lang="id" class="" position="right" />
          </li>

          <!-- <div class="relative p-0 rounded-[20px] w-[250px] max-w-lg"> -->
          <!-- <input type="text" class="rounded-[20px] p-3 w-full" name="search" placeholder="Cari"> -->
          <!-- </div> -->
          <!-- <li>
              <RouterLink to="addcustomer"
                class="md:p-4 py-3 block flex items-center justify-center w-[200px] h-[40px] rounded-md bg-[#50C996] text-black py-2.5 font-semibold"
              >
                Customer Baru
              </RouterLink>
            </li> -->

          <!-- <input type="date" v-model="date" class="flex-grow border-1 border-[#5FBAE6] rounded-md p-2" name="date"> -->
          <!-- <li>
            <button @click="filterDropdown = !filterDropdown" id="dropdownHoverButton"
              class="md:p-4 py-3 px-0 block flex items-center justify-center w-[100px] h-[40px] rounded-md bg-[#F5CA40] text-black px-6 py-2.5 font-semibold gap-2">
              Filter By <i class="bi bi-funnel-fill"></i>
            </button>
            <ul v-if="filterDropdown"
              class="absolute transform -translate-x-2  bg-slate-100 shadow-lg mt-2 rounded-lg w-30 space-y-2 p-1"> 
              <li
                class="block px-4 py-2 text-black font-redHat text-base hover:bg-[#5FBAE6]/80 hover:rounded-lg cursor-pointer"
                :class="{ 'bg-[#5FBAE6]/80 rounded-lg': selectedType === 'STORY_IG' }"
                @click="filterRecords('STORY_IG')">
                <div>List Order</div>
              </li>
              <li
                class="block px-4 py-2 text-black font-redHat text-base hover:bg-[#5FBAE6]/80 hover:rounded-lg cursor-pointer"
                :class="{ 'bg-[#5FBAE6]/80 rounded-lg': selectedType === 'LIVE_IG' }" @click="filterRecords('LIVE_IG')">
                <div>Live Instagram</div>
              </li>
            </ul>
          </li> -->
        </ul>
      </nav>
    </div>
  </header>

  <div class="px-5 pt-5 mb-2">
    <!-- <div class="flex flex-col">
              <div class=" overflow-x-auto">
                  <div class="p-1.5 min-w-full inline-block align-middle">
                      <div class="">
                      </div>
                  </div>
              </div>
          </div> -->

    <div class="overflow-scroll " style="max-height: 60vh;">
      <!-- for datatable -->
      <table id="example" class="display " style="width: 100%;">
        <thead style="position: sticky; top: 0; background-color: white; z-index: 1;">
          <tr v-if="filteredRecords.length > 0">
            <th>No.</th>
            <th>Instagram</th>
            <th>Customer</th>
            <th>Tanggal Deposit</th>
            <th>Bank</th>
            <th>Atas nama</th>
            <th>Jumlah Deposit</th>
            <!-- <th>Aksi</th> -->
          </tr>
        </thead>
        <tbody>
          <tr class="tr-table" v-for="(item, index) in filteredRecords" :key="item.id">
            <td class="custom-td-left ">{{ item.number }}</td>
            <!--<td><input type="text" v-model="item.ig" /></td> -->
            <td class="">
              <div class="m-2">
                <span class=""
                  v-if="filteredRecords[index - 1] != undefined && filteredRecords[index - 1].instagram == item.instagram">
                </span>
                <span class="" v-else>
                  {{ item.instagram }}
                </span>

              </div>

            </td>
            <td class="">
              <div class="m-2">
                <span class=""
                  v-if="filteredRecords[index - 1] != undefined && filteredRecords[index - 1].name == item.name">

                </span>
                <span class="" v-else>
                  {{ item.name }}
                </span>

                <!-- Dress -->
              </div>
            </td>
            <td class="">
              <div class="m-2">
                {{ item.deposit_date }}
              </div>

            </td>
            <td class="">
              <div class="m-2">
                {{ item.bank_name || '' }}
                <!-- Dress -->
              </div>
            </td>
            <td class="">
              <div class="m-2">
                {{ item.name_account || '' }}
              </div>
            </td>
            <td class="">
              <div class="m-2">
                <span class="fw-bold" v-if="item.id == 0">
                  {{ rupiah(item.amount) }}
                </span>
                <span v-else>
                  {{ rupiah(item.amount) }}
                </span>
                <!-- Rp.150.000 -->
              </div>

            </td>


            <!-- <td class="custom-td-right w-[150px]">
          <div class="flex justify-between">
            <button @click="editData(item)"
          class="inline-flex items-center text-lg font-semibold disabled:opacity-50 disabled:pointer-events-none">
          <!-- <i class="bi bi-pencil-fill"></i> 
          <i class="bi bi-receipt-cutoff"></i>
            </button>
            
            <button @click="editCustomer(item)"
          class="inline-flex items-center text-lg font-semibold disabled:opacity-50 disabled:pointer-events-none">
          <i class="bi bi-pencil"></i>
            <button @click="editCustomer(item)"
          class="inline-flex items-center text-lg font-semibold disabled:opacity-50 disabled:pointer-events-none">
          <i class="bi bi-pencil"></i>

            </button>
            <button type="button" @click="terminate(item.id)"
          class="inline-flex items-center gap-x-2 text-lg font-semibold ms-2 text-red-600 hover:text-red-800 disabled:opacity-50 disabled:pointer-events-none">
          <i class="bi bi-trash"></i>
            </button>

            <button type="button" @click="" v-if="item.id > 0"
          class="inline-flex items-center gap-x-2 text-lg font-semibold ms-2 text-black hover:text-red-800 disabled:opacity-50 disabled:pointer-events-none">
          <i class="bi bi-file-earmark-text"></i>
            </button>


          </div>

          <button @click="addRow" class="mt-4 p-2 bg-blue-500 text-white rounded-md">Add New Row</button>

          <button type="button"  @click="openModalDelete(index)" class="inline-flex items-center gap-x-2 text-lg font-semibold text-black hover:text-red-800 disabled:opacity-50 disabled:pointer-events-none">
                  <i class="bi bi-plus-circle-fill"></i>
                  </button>
        </td> -->
            <!-- <td>{{ item.position }}</td>
                <td>{{ item.office }}</td>
                <td>{{ item.age }}</td> -->
          </tr>
        </tbody>
      </table>
    </div>


  </div>




  <!-- modal delete -->
  <div v-if="isModalOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
    <!-- Modal content -->
    <div class="bg-white rounded-lg shadow-lg p-6 max-w-md w-full" @click.stop>
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-semibold">Delete Data Rekap</h2>
        <button @click="closeModal" class="text-red-600 hover:text-gray-900">
          ✕
        </button>
      </div>
      <p class="text-gray-700 mb-10">
        Are you sure wants to delete this data ?
      </p>

      <div class="space-y-3">
        <div aria-hidden="true" class="border-t px-2"></div>
        <div class="button-group flex justify-end">
          <button @click="closeModal" class="bg-gray-400 text-white font-bold py-2 px-4 rounded hover:bg-gray-700 me-3">
            Close
          </button>
          <button @click="delete2" class="bg-red-500 text-white font-bold py-2 px-4 rounded hover:bg-red-700">
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import NavBar from '@/components/NavBar.vue'
import axios from "axios";
// import Swal from 'sweetalert2';

import { ErrorConnectionTimeOut, ShowLoading, CloseLoading, base_url, AlertPopup, AlertBottom, rupiahInput, rupiah, goPage, DateFormat } from "@/assets/js/function";
// import {ErrorConnectionTimeOut,  ShowLoading, CloseLoading, base_url, AlertPopup,  rupiahInput,  rupiah } from "@/assets/js/function";
import Cookies from "js-cookie";
import Multiselect from 'vue-multiselect';
import 'vue-datepicker-ui/lib/vuedatepickerui.css';
import VueDatepickerUi from 'vue-datepicker-ui';
import XLSX from "xlsx/dist/xlsx.full.min.js";

export default {
  components: {
    NavBar,
    Multiselect,
    Datepicker: VueDatepickerUi
  },

  data() {
    return {
      searchQuery: '',

      records: [
        {
          total_deposit: '',
        }
      ],
      currentData: [],
      listStatusPesanan: [],
      isModalOpen: false,
      currentDeleteIndex: null,
      config: '',
      filterDropdown: false,
      selectedType: 'LIVE_IG',

      date: '',
      dateRange: [
        new Date(),
        new Date(new Date().getTime() + 9 * 24 * 60 * 60 * 1000)]

    }
  },

  watch: {
    // date: {
    //   handler(newVal) {
    //     this.index();
    //   },
    // }
    dateRange: {
      handler(newVal) {
        this.index();
      },
    }
  },

  created() {
    const token = Cookies.get("token");
    // console.log(token)
    this.config = {
      headers: { Authorization: `Bearer ` + token },
      timeout: 100000,
    }

    const date = new Date();
    this.date = date.toISOString().split('T')[0]; // Output: '2024-05-01'


    // console.log(this.config);
    this.index();
    this.prepareData();


    this.showMultiselect = false;

    // Load from localStorage when the component is created
    // const savedLiveIg = localStorage.getItem('records');
    // if (savedLiveIg) {
    // this.records = JSON.parse(savedLiveIg); // Load saved data into records
    // console.log('Stored records:', JSON.parse(savedLiveIg));
    // }else {
    // console.log('No records found in localStorage.');
    // }
  },

  computed: {
    filteredRecords() {
      // Check if searchQuery is valid (not undefined or empty string)
      if (!this.searchQuery || this.searchQuery.length < 4) {
        return this.records;
      }

      // Proceed with filtering if searchQuery is valid
      return this.records.filter(item => {
        const searchLower = this.searchQuery.toLowerCase();
        return (
          (item.instagram ? item.instagram.toLowerCase().includes(searchLower) : false) ||
          (item.name_account ? item.name_account.toLowerCase().includes(searchLower) : false) ||
          (item.name ? item.name.toLowerCase().includes(searchLower) : false) ||
          (item.price ? String(item.price).includes(searchLower) : false)
        );
      });
    }

  },


  // mounted() {
  //     this.$root.initializeDataTable(); 

  // },

  methods: {
    rupiah,

    nameWithLang({ name }) {
      return `${name}`;
    },


    addRow() {
      // Mark the row as "Added"
      //   this.record[index].isAdded = true

      // Add a new row with a unique id
      this.records.push({
        id_customer: '',
        id_produk: '',
        color: '',
        size: '',
        qty: '',
        price: '',
        deposit: '',
        isAdded: false
      })
    },

    getIconClass(item) {
      // Determine the icon class based on whether the row is the last one
      // return item.total_deposit > item.price ? 'bi bi-check-circle-fill text-gray-400' : 'bi bi-check-circle-fill text-[#50C996]' ;
      // console.log(item.total_deposit)
      // console.log(item.price)
      if (item.total_deposit >= item.price) {
        //return 'bi bi-check-circle-fill text-[#50C996]'; // Green verified
        return true
      }
      else {
        //return 'bi bi-check-circle-fill text-gray-400'; // Gray unverified
        return false
      }
    },

    // checkingLastRow(index) {
    //     if(index == this.records.length - 1) {
    //         // this.records[index].isAdded = true;
    //         return true;

    //             // this.records.splice(index + 1, 0, );
    //     }else {
    //         // this.records[index].isAdded = false;
    //         return false;

    //     }
    // },

    formatCurrency(label, number, index) {
      this.records[index][label] = rupiahInput(number);

    },


    addNumberToObjects(objArray) {
      let no = 1;


      for (let i = 0; i < objArray.length; i++) {
        const { number, deposit_date, name_account, bank_name, name, instagram, amount, deposit_date_sistem, ...rest } = objArray[i];
        // number,
        // let expedition_info_text = expedition_info;
        // if (expedition_info !== '') {
        //   expedition_info_text = ' (' + expedition_info + ') ';
        // }

        // const isSameCustomer = i > 0 && objArray[i - 1]['Id Customer'] === counter_customer;



        const newObj = {
          // No: objArray[i - 1] != undefined && objArray[i - 1]['Id Customer'] == counter_customer ? '' : no,
          // No: isSameCustomer ? '' : no, // Increment `No` only for new customers
          No: number,
          "Instagram": instagram,
          "Customer": name,
          // "ID Customer": counter_customer,
          "Tanggal Deposit Input": deposit_date,
          "Tanggal Input ": deposit_date_sistem,
          "Bank": bank_name,
          "Atas Nama": name_account,
          "Jumlah Deposit": amount,

          // "Status Pesanan": order_status,
          // "Ekspedisi": expedition + expedition_info_text,
          // "Nama Admin": nama_admin,
          // "Tipe Jual": type == 'LIVE_IG' ? 'LIVE IG' : 'STORY IG',
          // "Total Sales": price,
          // "Deposit": total_deposit,
          // "Status": status_customer,
          // "Order": order,
          // "Qty": qty,
          // "Total": total_qty + ' PCS',
          ...rest
        };

        // console.log('ini obj dari laporan deposit:', newObj)
        // if (objArray[i - 1] == undefined || objArray[i - 1]['Id Customer'] != counter_customer) {
        //   no++;
        // }

        // if (!isSameCustomer) {
        //     no++; // Increment `no` for new customers
        // }

        objArray[i] = newObj;
      }
      return objArray;
    },

    convertToExcel() {
      ShowLoading();

      // Create a deep copy of `this.records` to avoid modifying the original data
      const data = JSON.parse(JSON.stringify(this.records));
      let ArrExport = this.addNumberToObjects(data);

      // Filter out duplicate entries (rows without a "No")
      ArrExport = ArrExport.filter(row => row.No !== undefined);

      for (let i = 0; i < ArrExport.length; i++) {
        delete ArrExport[i]["id"];
        delete ArrExport[i]["id_profiles"];
        delete ArrExport[i]["id_preorder"];
        delete ArrExport[i]["id_customer"];
        delete ArrExport[i]["Id Customer"];
        delete ArrExport[i]["ID Customer"];
        delete ArrExport[i]["number"];
        delete ArrExport[i]["name"];
        delete ArrExport[i]["id_product"];
        delete ArrExport[i]["Deposit"];
        delete ArrExport[i]["Status"];
        delete ArrExport[i]["Tipe Jual"];
        delete ArrExport[i]["Tipe Sales"];

        if (ArrExport[i]['No'] == '') {
          // ArrExport[i]["Ekspedisi"] = '';
          // ArrExport[i]["Tanggal Deposit"] = '';
          // ArrExport[i]["Bank"] = '';
          // ArrExport[i]["Atas Nama"] = '';
          // ArrExport[i]["Jumlah Deposit"] = '';



        }
      }


      // Create a new workbook
      const wb = XLSX.utils.book_new();
      // Create a new worksheet
      const ws = XLSX.utils.json_to_sheet(ArrExport);
      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(wb, ws, 'REKAP');
      // Convert the workbook to an XLSX file and download it
      XLSX.writeFile(wb, 'DEPOSIT REPORT' + ".xlsx");
      CloseLoading();
    },


    prepareData() {
      // this.records.total_deposit = rupiahInput(this.records.total_deposit);
      this.records.forEach((item) => {
        item.total_deposit = rupiahInput(item.total_deposit);
      });

    },
    editData(item) {
      // for batal edit customer page
      localStorage.setItem('currentData', JSON.stringify(item));
      goPage('editverifikasiliveig');
    },
    editCustomer(item) {
      // for batal edit customer page
      this.$router.push({ name: 'editcustomer' });
      sessionStorage.setItem('lastPage', 'verifikasi-live-ig');

      // console.log(item)
      localStorage.setItem('currentData', JSON.stringify(item.customer_detail));

      // Navigate to the Add Customer page
      this.$router.push({ name: 'editcustomer' });
    },

    filterRecords(type) {
      this.selectedType = type; // Save the selected filter type
      this.index(); // Call the index method to fetch filtered data
    },

    index() {
      ShowLoading();
      let formData = new FormData();

      formData.append('id_preorder', localStorage.getItem('id_preorder'))

      const startDate = this.dateRange[0];
      const StartformattedDate = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}`;

      formData.append('date_from', StartformattedDate);

      const beforeDate = this.dateRange[1];
      const BeforeformattedDate = `${beforeDate.getFullYear()}-${String(beforeDate.getMonth() + 1).padStart(2, '0')}-${String(beforeDate.getDate()).padStart(2, '0')}`;

      formData.append('date_end', BeforeformattedDate);

      // formData.append('type', 'LIVE_IG');
      // formData.delete("total_deposit");
      // formData.append('total_deposit', rupiahoutput(item.total_deposit));

      if (process.env.NODE_ENV === "development") {
        this.api = base_url + 'report_deposit';
      } else {
        this.api = base_url + 'report_deposit';
      }

      axios
        .post(this.api, formData, this.config)
        .then((response) => {
          if (response.data.status === true) {

            this.records = response.data.data;

            // Step 1: Calculate total prices for each customer
            const totalAmounts = this.records.reduce((acc, order) => {
              const { id_customer, amount } = order;

              // Initialize the total amount if the id_customer doesn't exist in acc
              if (!acc[id_customer]) {
                acc[id_customer] = 0; // Initialize total amount
              }

              // Accumulate total amount
              acc[id_customer] += amount;

              return acc;
            }, {});


            // Step 2: Create a new array and insert orders and totals
            const result = [];

            let number = 1;
            // Iterate through the original orders
            for (let i = 0; i < this.records.length; i++) {
              const order = this.records[i];
              if (this.records[i - 1] != undefined && this.records[i - 1].id_customer == this.records[i].id_customer) {
                order.number = '';
              } else {
                order.number = number;
                number++;
              }
              result.push(order); // Push the original order

              const { id_customer } = order;

              // Check if this is the last order for this customer
              const isLastOrder = (i === this.records.length - 1) || (this.records[i + 1].id_customer !== id_customer);

              // If it is the last order for this customer, add the total row
              if (isLastOrder) {
                const totalOrder = {
                  id: 0, // Set id to 0
                  id_customer: id_customer,
                  instagram: order.instagram,
                  name: order.name,
                  name_account: "",
                  deposit_date: "",
                  amount: totalAmounts[id_customer], // Total price for this customer
                };

                result.push(totalOrder); // Insert total order immediately after the last order for this customer
              }
            }
            console.log(result);
            this.records = result;

            // this.filteredRecords = this.records.filter(
            //   (item) => item.type === this.selectedType
            // );


            this.dataCustomer = response.data.customer; //to fetch customer
            this.dataProduct = response.data.product; //to fetch product
            // localStorage.setItem('data_status_order', JSON.stringify(response.data.status_order));
            // this.listStatusPesanan = response.data.status_order;
            // this.listStatusPesanan.push({ id: 0, name: 'PENDING' });
            // this.dataColor = response.data.data; //to fetch color
            //this.dataSize = response.data.data; //to fetch size

            // this.records.forEach((item) => {
            //   const index = this.listStatusPesanan.findIndex((status) => status.id == item.id_order_status); // Use `status` instead of `item`
            //   if (index !== -1) {
            //     item.id_order_status = this.listStatusPesanan[index];  // Assign the matched status to item.id_order_status
            //   }
            // });





            // save to local storage
            // localStorage.setItem('data_supplier', JSON.stringify(response.data.data_supplier));
            localStorage.getItem('id_preorder')
            // localStorage.setItem('data_product_detail', JSON.stringify(response.data.product_detail));


            // if (response.data.status == true) {
            //     this.data = [];

            //     response.data.data.forEach((item, index) => {
            //         let item_prepare = { ...item, no: (index + 1), };
            //         this.data.push(item_prepare);
            //     });

            //     CloseLoading();
            // }


            CloseLoading();
          } else {
            CloseLoading();
            AlertPopup("error", "", response.data.message, 1500, false);
          }
        })
        .catch((error) => {
          CloseLoading();
          ErrorConnectionTimeOut(error);
        });
    },

    openModalDelete() {
      // this.currentDeleteIndex = index;

      this.isModalOpen = true;
    },

    closeModal() {
      this.isModalOpen = false;
      this.id_terminate = null;
    },

    delete2() {
      ShowLoading();
      let formData = new FormData();
      formData.append("id", this.id_terminate);


      // for (let [key, value] of formData.entries()) {
      //     console.log(`${key}: ${value}`);
      // }
      // CloseLoading()
      // return true;

      if (process.env.NODE_ENV === "development") {
        this.api = base_url + 'live_ig_delete';
      } else {
        this.api = base_url + 'live_ig_delete';
      }

      axios
        .post(this.api, formData, this.config)
        .then((response) => {

          if (response.data.status == true) {
            const index = this.records.findIndex((item) => item.id === this.id_terminate); // Find item in the array by ID
            this.records.splice(index, 1); // Remove the item from the array
            CloseLoading();
            this.closeModal(); // Close modal after deletion
            AlertBottom(response.data.message);

          } else {
            AlertPopup("error", "", response.data.message, 1500, false);
          }
        })
        .catch((error) => {

          ErrorConnectionTimeOut(error);
        });


    },

    terminate(id) {
      this.id_terminate = id;
      this.openModalDelete();
      // this.tanggal_terminate = new Date();

    },

    //   openModalDelete(index) {
    //       this.currentDeleteIndex = index;

    //       this.isModalOpen = true;
    //   },
    //   closeModal() {
    //       this.isModalOpen = false;
    //   },
    //   confirmDelete() {
    //       // Handle the actual deletion here
    //       if (this.currentDeleteIndex !== null) {
    //           this.records.splice(this.currentDeleteIndex, 1);  // Delete the item
    //           this.closeModal();  // Close the modal after deletion
    //       }
    //   },
  }
}
</script>

<style scoped>
/* Adjust positioning and z-index for the multiselect dropdown */
.multiselect__content {
  position: absolute;
  z-index: 9999;
  top: 100%;
}

.multiselect-full-width .multiselect__select {
  width: 100%;
}

.no-arrows {
  -moz-appearance: textfield;
  /* Firefox */
  appearance: none;
  /* Remove default appearance */
}

.no-arrows::-webkit-outer-spin-button,
.no-arrows::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* Chrome, Safari, Edge */
  margin: 0;
  /* Remove margin */
}
</style>